import { configs } from '@constants/configs/configs';
import { PAGE_SIZE } from '@constants/common.constants';
import { CAP_HISTORICAL_NOTICES_ACTION_TYPES } from '@constants/actionTypes/capHistoricalNoticesActionTypes';
import { createPaginatedFetchThunk } from '@common-actions/createPaginatedFetchThunk';
import {
    HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
    HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
    HISTORICAL_NOTICES_LIST_KEY,
    type IHistoricalNoticesPageData,
} from '@modules/historical-notices/constants';
import type {
    ICapHistoricalNoticesFetchRequest,
    ICapHistoricalNoticesListState,
} from '@modules/historical-notices/cap/cap.types';

const buildBasePayload = (request: ICapHistoricalNoticesFetchRequest) => ({
    hasLoaded: true,
    notices: [],
    totalCount: 0,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize,
    totalPages: 0,
    sortColumn: request.sortColumn,
    sortOrder: request.sortOrder,
});

export const setCapHistoricalNotices = (payload: ICapHistoricalNoticesListState) => ({
    type: CAP_HISTORICAL_NOTICES_ACTION_TYPES.SET_CAP_HISTORICAL_NOTICES,
    payload,
});

export const resetCapHistoricalNotices = () => ({
    type: CAP_HISTORICAL_NOTICES_ACTION_TYPES.RESET_CAP_HISTORICAL_NOTICES,
});

export const fetchCapHistoricalNotices = createPaginatedFetchThunk<
    ICapHistoricalNoticesFetchRequest,
    IHistoricalNoticesPageData,
    typeof HISTORICAL_NOTICES_LIST_KEY,
    ICapHistoricalNoticesListState
>({
    getEndpointUrl: () => configs.endpoints.HISTORICAL_NOTICES,
    listKey: HISTORICAL_NOTICES_LIST_KEY,
    setList: setCapHistoricalNotices,
    requestDefaults: {
        pageNumber: HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
        pageSize: PAGE_SIZE,
        sortColumn: HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
        sortOrder: HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    },
    
    buildQueryParams: (request) => ({ userRefId: request.userRefId ?? '' }),
    buildEmptyPayload: (request) => ({
        ...buildBasePayload(request),
        hasLoadError: false,
    }),
    buildErrorPayload: (request) => ({
        ...buildBasePayload(request),
        hasLoadError: true,
    }),
    buildSuccessPayload: (pageData, request) => ({
        ...buildBasePayload(request),
        notices: pageData.userHistoricalNotices,
        totalCount: pageData.totalElements,
        pageNumber: pageData.pageNumber,
        pageSize: pageData.pageSize,
        totalPages: pageData.totalPages,
        hasLoadError: false,
    }),
});
